export const productCategoryOptions = [
  // 'Cakes',
  // 'Spreads',
  'Celebration Cakes',
  'Customized Cakes',
  'Cheese Cakes',
  'Courses',
  'Plum Cakes',
  'Wedding Cakes',
  'Gifts & Hampers',
];

export const pickStatusColor = {
  Pending: 'primary',
  'Order failed': 'error',
  Processed: 'info',
  Delivered: 'success',
  Confirmed: 'warning',
};

export const orderStatus = [
  'Pending',
  'Order failed',
  'Processed',
  'Delivered',
  'Confirmed',
  'Out for delivery',
];

export const cutoffHours = 12;

export const deliveryTimeSlots = [
  [15, 17],
  [17, 19],
];

export const convertTo12HourFormat = hour => {
  if (hour === 12) {
    return '12 PM';
  }
  if (hour > 12) {
    return hour - 12 + ' PM';
  }
  if (hour === 0) {
    return '12 AM'; // Midnight
  }
  return hour + ' AM'; // For hours between 1 and 11 (AM)
};

export const appColor = '#b59410';

export const appMultipleOptions = [
  'Customized Cakes',
  'Cheese Cakes',
  'Wedding Cakes',
  'Celebration Cakes',
];

export const customSelectTitles = {
  'Biscoff Cheesecake': 'Pick your quantity',
  'Black Forest Cake': 'Pick your quantity',
  'White Forest Cake': 'Pick your quantity',
  'Chocolate Truffle Cake': 'Pick your quantity',
  'Fruit Cake': 'Pick your quantity',
  'Rich Plum Cake': 'Pick your quantity',
  'Chandlier Cake': 'Pick your quantity',
};

export const onlyWhatsappOrders = ['687e9b5200667190b3cf0df7'];
